import { SpinnerFixedPosition, Typography } from '@stern-ui/ui';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { store } from '@/stores/store';

const ErrorFallback = () => {
	return (
		<div
			className='text-error w-screen h-screen flex flex-col justify-center items-center'
			role='alert'
		>
			<Typography variant='display2'>Ooops, something went wrong :( </Typography>
		</div>
	);
};

type AppProviderProps = {
	children: React.ReactNode;
};

export const AppProvider = (props: AppProviderProps) => {
	const { children } = props;
	return (
		<React.Suspense fallback={<SpinnerFixedPosition size='xl' variant='light' />}>
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<HelmetProvider>
					<Provider store={store}>{children}</Provider>
				</HelmetProvider>
			</ErrorBoundary>
		</React.Suspense>
	);
};
